import axios from "axios";

// Create instance
const api = axios.create({
  baseURL:
    "https://py-web-api.onrender.com/",
  withCredentials: true, // if you're using cookies
});

// const api = axios.create({
//   baseURL: "http://localhost:8000/",
//   withCredentials: true, // if you're using cookies
// });

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Attach token
    const user = localStorage.getItem("user"); // or from a context/store
    const token = user ? JSON.parse(user)?.access_token : null; // Adjust based on your user object structure

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Optional: Set content type
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized globally
    if (error.response && error.response.status === 401) {
      // Optional: redirect to login or clear session
      localStorage.removeItem("user");
      window.location.href = "/auth";
    }

    // Optionally log error or show toast
    return Promise.reject(error);
  }
);

export default api;
